export default "__VITE_ASSET__484772ae__"